import { TwitterImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={TwitterImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
